var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cms-editor d-flex flex-column"
  }, [_c('div', {
    staticClass: "cms-editor-ctn d-flex flex-row flex-grow-1"
  }, [_c('div', {
    staticClass: "toolbox-ctn font-weight-light flex-shrink-0"
  }, [_c('div', {
    staticClass: "toolbox my-6"
  }, [_c('div', {
    staticClass: "tool-section-header"
  }, [_vm._v(_vm._s(_vm.$t('cms_sku_specific_elements')))]), _c('draggable', {
    attrs: {
      "clone": _vm.cloneTool,
      "list": _vm.skuTools,
      "sort": false,
      "group": {
        name: 'a',
        pull: _vm.checkClone,
        put: false
      }
    }
  }, _vm._l(_vm.skuTools, function (tool, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isAvailable("editor:tabs:tools:".concat(tool.type)),
        expression: "isAvailable(`editor:tabs:tools:${tool.type}`)"
      }],
      key: "sku-tool-".concat(index),
      staticClass: "tool pa-2 my-2",
      class: {
        'hide': tool.scantrustOnly && !_vm.isAdmin,
        'disabled': _vm.getToolCount(tool.type) >= _vm.getLimit("editor:tabs:tools:".concat(tool.type))
      },
      attrs: {
        "data-type": tool.type
      },
      on: {
        "click": function click($event) {
          return _vm.addTool(tool);
        }
      }
    }, [_c('v-row', {
      staticClass: "ma-0"
    }, [_c('v-icon', {
      staticClass: "mr-2",
      attrs: {
        "color": "black"
      }
    }, [_vm._v(_vm._s(tool.icon))]), _vm._v(" " + _vm._s(tool.description) + " "), _c('v-spacer'), _c('v-icon', {
      attrs: {
        "color": "black"
      }
    }, [_vm._v("mdi-auto-fix")])], 1)], 1);
  }), 0), _c('v-divider', {
    staticClass: "my-5"
  }), _c('div', {
    staticClass: "tool-section-header"
  }, [_vm._v(_vm._s(_vm.$t('cms_standard_webpage_elements')))]), _c('draggable', {
    attrs: {
      "clone": _vm.cloneTool,
      "list": _vm.tools,
      "sort": false,
      "group": {
        name: 'a',
        pull: _vm.checkClone,
        put: false
      }
    }
  }, _vm._l(_vm.tools, function (tool, index) {
    return _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isAvailable("editor:tabs:tools:".concat(tool.type)),
        expression: "isAvailable(`editor:tabs:tools:${tool.type}`)"
      }],
      key: "tool-".concat(index),
      staticClass: "tool pa-2 my-1",
      class: {
        'hide': tool.scantrustOnly && !_vm.isAdmin,
        'disabled': tool.type === 'photo_auth' ? _vm.getToolCount(tool.type) == 1 : _vm.getToolCount(tool.type) >= _vm.getLimit("editor:tabs:tools:".concat(tool.type))
      },
      attrs: {
        "data-type": tool.type,
        "disabled": tool.type === 'photo_auth' ? _vm.getToolCount(tool.type) == 1 : _vm.getToolCount(tool.type) >= _vm.getLimit("editor:tabs:tools:".concat(tool.type))
      },
      on: {
        "click": function click($event) {
          return _vm.addTool(tool);
        }
      }
    }, [_c('v-row', {
      staticClass: "ma-0"
    }, [_c('v-col', {
      staticClass: "pa-0 mr-auto",
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "black"
      }
    }, [_vm._v(_vm._s(tool.icon))]), _vm._v(" " + _vm._s(tool.description) + " ")], 1), _vm.hasLimit("editor:tabs:tools:".concat(tool.type)) ? _c('v-col', {
      staticClass: "pa-0",
      attrs: {
        "cols": "auto"
      }
    }, [_c('span', {
      staticClass: "limit"
    }, [_vm._v(_vm._s(_vm.$t('cms_up_to')) + " " + _vm._s(_vm.getLimit("editor:tabs:tools:".concat(tool.type))))])]) : _vm._e()], 1)], 1);
  }), 0), _vm.isAvailable('editor:tabs:tools:elabel') ? [_c('v-divider', {
    staticClass: "my-5"
  }), _c('div', {
    staticClass: "tool-section-header"
  }, [_vm._v(" " + _vm._s(_vm.$t('cms_elabel_elements')) + " "), _c('info-tooltip', {
    attrs: {
      "content": _vm.$t('cms_elabel_elements_hint')
    }
  })], 1), _c('draggable', {
    attrs: {
      "clone": _vm.cloneTool,
      "list": _vm.elabelTools,
      "sort": false,
      "group": {
        name: 'a',
        pull: _vm.checkClone,
        put: false
      }
    }
  }, _vm._l(_vm.elabelTools, function (tool, index) {
    return _c('button', {
      key: "elabel-tool-".concat(index),
      staticClass: "tool pa-2 my-1 d-flex align-center text-left",
      attrs: {
        "data-type": tool.type
      },
      on: {
        "click": function click($event) {
          return _vm.addTool(tool);
        }
      }
    }, [_c('v-icon', {
      staticClass: "mr-2",
      attrs: {
        "color": "black"
      }
    }, [_vm._v(_vm._s(tool.icon))]), _c('span', [_vm._v(_vm._s(tool.description))])], 1);
  }), 0)] : _vm._e()], 2), !_vm.isAvailable('editor:authentication') && !_vm.isSelfServe ? _c('div', {
    attrs: {
      "align-content": "center",
      "justify": "start"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('cms_need_more_elements')))]), _c('info-tooltip', {
    staticClass: "more-tooltip ml-3",
    attrs: {
      "content": _vm.$t('cms_upgrade_unlock_features')
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "content-ctn px-2 flex-grow-1 flex-shrink-1"
  }, [_c('v-text-field', {
    staticClass: "page-title",
    attrs: {
      "disabled": !_vm.isAvailable('editor:global:title'),
      "dense": "",
      "placeholder": _vm.$t('cms_enter_page_title')
    },
    model: {
      value: _vm.pageTitle,
      callback: function callback($$v) {
        _vm.pageTitle = $$v;
      },
      expression: "pageTitle"
    }
  }), _c('div', {
    staticClass: "drop-area-ctn flex-grow-1 flex-shrink-1 pa-2"
  }, [_c('div', {
    staticClass: "drop-area-header font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('cms_content_layout_drag')))]), _c('draggable', {
    staticClass: "drop-area flex-shrink-1",
    attrs: {
      "disabled": _vm.editingContent,
      "group": "a"
    },
    model: {
      value: _vm.tabBody,
      callback: function callback($$v) {
        _vm.tabBody = $$v;
      },
      expression: "tabBody"
    }
  }, _vm._l(_vm.tabBody, function (tool) {
    return _c('div', {
      key: "active-tool-".concat(_vm.tabId, "-").concat(tool.key),
      staticClass: "tool my-2"
    }, [_c('cms-tool', {
      attrs: {
        "icon": "".concat(tool.icon),
        "type": tool.type,
        "tool-key": tool.key,
        "data": tool.data,
        "styles": tool.styles,
        "tab-id": _vm.tabId,
        "lang": _vm.defaultLanguage
      }
    })], 1);
  }), 0)], 1)], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }